import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const BrandForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [brandName, setBrandName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("Brand")
        .select("name")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Failed to load brand",
              showConfirmButton: false,
              timer: 3000,
              toast: true,
              background: "white",
              customClass: { popup: "shadow-lg rounded-md p-3" },
            });
            navigate("/brand");
          } else {
            setBrandName(data.name);
          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    const name = brandName.trim();
    if (!name) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Please enter a brand name",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
      return;
    }

    setLoading(true);

    const normalized = name.toLowerCase();

    const { data: existing } = await supabase
      .from("Brand")
      .select("id, name");

    const exists = existing?.some(
      (row) => row.name.trim().toLowerCase() === name.toLowerCase()
    );

    if (!id && exists) {
      setLoading(false);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `"${name}" already exists`,
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
      return;
    }

    if (id && existing?.some(
      (row) =>
        row.name.trim().toLowerCase() === name.toLowerCase() && row.id !== id
    )) {
      setLoading(false);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `"${name}" already exists`,
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
      return;
    }


    if (id) {
      const { error } = await supabase
        .from("Brand")
        .update({ name })
        .eq("id", id);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to update brand",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Brand updated successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        navigate("/brand");
      }
    }

    else {
      const { error } = await supabase
        .from("Brand")
        .insert([{ name }]);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to add brand",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Brand added successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        navigate("/brand");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Brand" : "Add Brand"}
          </h1>

          <div>
            <label
              htmlFor="brandName"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter brand name
            </label>

            <input
              id="brandName"
              name="brandName"
              type="text"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
              placeholder="Enter brand name"
              autoFocus
              disabled={loading}
              className="w-full px-4 py-3 border border-gray-300 rounded-md 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/brand")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BrandForm;
